import script from "./BoardList.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardList.vue?vue&type=script&setup=true&lang=js"

import "./BoardList.vue?vue&type=style&index=0&id=1a9beb7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a9beb7c"]])

export default __exports__